import Modal from "@src/components/UIElements/Modal";
// import { Image } from "@src/components/Image";
import React, { useEffect, useState } from "react";
import Button from "@src/components/UIElements/Button";
import styles from "./CourseFacultyListBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { useTranslation } from "react-i18next";
import {
  courseFacultyListAction,
  setComboCourseId,
  setComboCourseListAction,
} from "@src/components/Tabs/Overview/store/actions.js";
import { initialisePaymentService } from "@src/PaymentService";
import SelectMultipleComboBox from "./components/SelectMultipleComboBox";
import SelectRadioComboBox from "./components/SelectRadioComboxBox";
import { addressEditModeToggleAction } from "../../../PhysicalAddress/store/actions";
import { useRouter } from "@src/lib/router";

const SelectStatesBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const router = useRouter();

  const [errorStates, setErrorStates] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [multipleSelectedCourses, setMultipleSelectedCourse] = useState({});
  const [singleSelectedCoruses, setSingleSelectedCourses] = useState({});
  const [physicalDeliveryEnabledStates, setPhysicalDeliveryEnabledStates] =
    useState({});
  const [physicalDeliveryState, setPhysicalDeliveryState] = useState(null);

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );

  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );

  const courseFacultyList = useSelector(
    (state) => state?.overviewReducer?.courseFacultyList
  );

  const enablePrefilledState = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.enablePrefilledState
  );

  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showSelectStateBottomSheet
  );

  const selectedState = useSelector(
    (state) => state?.overviewReducer?.stateSelected
  );

  const orgCode = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.orgDetails?.code
  );

  const overviewReducer = useSelector((state) => state?.overviewReducer);

  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );

  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );
  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );

  console.log(activeAddress, "indilwandlinwadilnwli");

  const handleBuyNow = () => {
    const arr1 = Object.keys(singleSelectedCoruses)
      .map((item) => {
        if (singleSelectedCoruses[item]) {
          return Number(item);
        }
        // If the condition is not met, return null or any other value you want to skip
        return null;
      })
      .filter((item) => item !== null);

    const arr2 = Object.keys(multipleSelectedCourses)
      .map((item) => {
        if (multipleSelectedCourses[item]) {
          return Number(item);
        }
        // If the condition is not met, return null or any other value you want to skip
        return null;
      })
      .filter((item) => item !== null);

    const comboCourseIds = [...arr1, ...arr2];
    const comboId = courseFacultyList?.comboId;

    if (physicalDeliveryState && physicalDeliveryState > 0) {
      // HANDLE PHYSICAL DELIVERY CASES
      if (!activeAddress) {
        router.push(`/${router?.query.courseId}/physicaladdress`);
        // dispatch(actionCreator.showSelectAddressBottomSheetAction(false));
        dispatch(setComboCourseListAction(comboCourseIds));
        dispatch(setComboCourseId(comboId));
        dispatch(actionCreator.courseFacultyListModalAction(false));
      } else {
        // dispatch(addressEditModeToggleAction(false));
        // router.push(`/${router?.query.courseId}/physicaladdress`);
        dispatch(actionCreator.showSelectAddressBottomSheetAction(true));
        dispatch(setComboCourseListAction(comboCourseIds));
        dispatch(setComboCourseId(comboId));
        dispatch(actionCreator.courseFacultyListModalAction(false));
      }
    } else {
      dispatch(setComboCourseListAction(comboCourseIds));
      dispatch(setComboCourseId(comboId));
      // NON-PHYSICAL DELIVERY CASES
      initialisePaymentService(comboCourseIds, comboId);
      dispatch(actionCreator.courseFacultyListModalAction(false));
    }
  };

  const handleCheckboxChange = (selected) => {
    setMultipleSelectedCourse((prev) => ({ ...prev, ...selected }));
  };

  const handleRadioChange = (selected) => {
    setSingleSelectedCourses((prev) => ({ ...prev, ...selected }));
  };

  // console.log(
  //   multipleSelectedCourses,
  //   singleSelectedCoruses,
  //   errorStates,
  //   "lindwliandilawnd"
  // );

  useEffect(() => {
    if (isComboActive && courseId) {
      dispatch(courseFacultyListAction(courseId));
    }
  }, [isComboActive]);

  useEffect(() => {
    // CHECK FOR ERRORS
    let isError = Object.keys(errorStates).some(
      (key) => errorStates[Number(key)] === true
    );

    if (isError) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [errorStates]);

  useEffect(() => {
    const values = Object.values(physicalDeliveryEnabledStates);

    let temp = 0;
    for (let i = 0; i < values.length; i++) {
      if (typeof values[i] === "number" && values[i] > 0) {
        if (i > values[i]) {
          temp = values[i];
        }
      }
    }

    if (temp > 0) {
      setPhysicalDeliveryState(temp);
    } else {
      setPhysicalDeliveryState(null);
    }
  }, [physicalDeliveryEnabledStates]);

  const title = courseFacultyList?.title;
  const errorText = courseFacultyList?.errorText;

  return (
    <div className={styles.facultyList}>
      <Modal
        showModal={state}
        handleClose={() => {
          dispatch(actionCreator.courseFacultyListModalAction(false));
        }}
        header={<div className={styles.facultyList__header}>{title}</div>}
      >
        {/* ERROR TEXT */}
        {errorText && (
          <div
            style={{
              marginBottom: "16px",
              textAlign: "center",
              color: "#EB5757",
            }}
          >
            {errorText}
          </div>
        )}
        <div className={styles.facultyList__cardContainer}>
          {courseFacultyList &&
            courseFacultyList?.courses?.map((items, index) => {
              const isMultiple = items?.subjectIdLimit > 1;

              if (isMultiple) {
                return (
                  <SelectMultipleComboBox
                    key={index}
                    index={index}
                    limit={items?.subjectIdLimit}
                    items={items?.value}
                    title={items?.name}
                    setErrorStates={setErrorStates}
                    handleCheckboxChange={handleCheckboxChange}
                    setPhysicalDeliveryEnabledStates={
                      setPhysicalDeliveryEnabledStates
                    }
                  />
                );
              } else {
                return (
                  <SelectRadioComboBox
                    key={index}
                    index={index}
                    limit={items?.subjectIdLimit}
                    items={items?.value}
                    title={items?.name}
                    setErrorStates={setErrorStates}
                    handleRadioChange={handleRadioChange}
                    setPhysicalDeliveryEnabledStates={
                      setPhysicalDeliveryEnabledStates
                    }
                  />
                );
              }
            })}
        </div>

        {courseFacultyList && courseFacultyList?.courses?.length > 0 && (
          <div
            className={
              styles.facultyList__ModalFooter +
              (enablePrefilledState ? " " + styles.fullWidthButton : "")
            }
          >
            <Button disabled={isDisabled} onClick={handleBuyNow}>
              {purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1 ? t(
                "components.bottomSheets.components.selectStateBottomSheet.proceed",
                "Proceed"
              ) : t(
                "components.bottomSheets.components.selectStateBottomSheet.proceedToPayment",
                "Proceed to Payment"
              )}
            </Button>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default SelectStatesBottomSheet;
